// problems#index — the public catalogue. The only behaviour here is the
// rating filter: the form works as a plain GET without JS, and when JS is
// available we submit on change and drop the now-redundant Apply button.
import { registerPage } from "../first"

function mountRatingFilter(): void {
  const form = document.querySelector<HTMLFormElement>("[data-rating-filter]")
  if (!form) return

  // Flips the stylesheet rule that hides Apply — set here rather than in the
  // ERB so the button stays for anyone whose JS never runs. iOS Safari fires
  // change on every scroll of a picker wheel, so the button also stays put on
  // coarse pointers where auto-submit would resubmit mid-selection.
  if (!window.matchMedia("(pointer: coarse)").matches) {
    form.setAttribute("data-auto-submit", "")
  }

  form.addEventListener("change", (event) => {
    if (!form.hasAttribute("data-auto-submit")) return
    if (!(event.target instanceof HTMLSelectElement)) return
    form.submit()
  })
}

export const ProblemsIndexPage = {
  onDomReady(): void {
    mountRatingFilter()
  },
}

registerPage("ProblemsIndexPage", ProblemsIndexPage)
